<template>
    <div class="app-container">
        <!-- 顶部导航栏 -->
        <div class="header">
            <div class="logo-placeholder">
                <img style="width: 45px;height: 45px;" src="../assets/image/logo1.png" alt="">
            </div>
            <span class="header-title">不良资产兑换中心</span>
        </div>

        <!-- Banner区域 -->
        <div class="banner">
            <img style="width: 100%;" src="../assets/image/banner.jpg" alt="">
        </div>

        <!-- 主要功能区 -->
        <div class="container">
            <!-- 平台资讯 -->
            <div class="function-card" @click="goNews">
                <div class="card-icon">
                    <img src="../assets/image/icon3.png" alt="">
                </div>
                <div class="card-text">平台简介</div>
            </div>

            <!-- 兑换中心 -->
            <div class="function-card" @click="goExchange">
                <div class="card-icon">
                    <img src="../assets/image/icon4.png" alt="">
                </div>
                <div class="card-text">兑换中心</div>
            </div>

            <!-- 个人中心 -->
            <div class="function-card" @click="goPersonal">
                <div class="card-icon">
                    <img src="../assets/image/icon5.png" alt="">
                </div>
                <div class="card-text">个人中心</div>
            </div>
        </div>
        <tab-bar></tab-bar>
    </div>
</template>

<script setup>
import TabBar from "@/components/tabbar/TabBar.vue";
import { useRouter } from 'vue-router'

const router = useRouter()

const goNews = () => {
    router.push({
        path: '/jianjie'
    })
}

const goExchange = () => {
    router.push({
        path: '/lottery'
    })
}

const goPersonal = () => {
    router.push({
        path: '/personal'
    })
}
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.app-container {
    min-height: 100vh;
    background-color: #0a1628;
    padding: 0 10px;
    color: #ffffff;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

/* 顶部导航栏 */
.header {
    display: flex;
    align-items: center;
    padding: 12px 0px;
}

.logo-placeholder {
    border-radius: 50%;
    /* margin-right: 12px; */
}

.header-title {
    font-size: 23px;
    font-weight: 500;
}

/* Banner区域 */
.banner {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
}

.container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 20px;
}

/* 功能卡片 */
.function-card {
    background-color: #1a2f4a;
    border-radius: 12px;
    padding: 20px;
    display: flex;
    flex-direction: row; /* 水平排列 */
    align-items: center; /* 垂直居中 */
    justify-content: center; /* 水平居中 */
    text-align: center; /* 文字居中 */
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.function-card:hover {
    background-color: #2a3f5a;
}

.card-icon {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    margin-right: 16px; /* 图标与文字间距 */
    flex-shrink: 0;
}

.card-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.card-text {
    font-size: 20px;
    font-weight: 500;
    color: #ffffff;
}

/* 响应式调整 */
@media (max-width: 480px) {
    .app-container {
        padding: 0 8px;
    }

    .container {
        gap: 12px;
    }

    .function-card {
        padding: 25px;
    }

    .card-icon {
        width: 40px;
        height: 40px;
        /* margin-bottom: 10px; */
    }

    .card-text {
        font-size: 22px;
    }
}
</style>